import { render, staticRenderFns } from "./FormSocialProfileQuestionSettings.vue?vue&type=template&id=3f39ced5"
import script from "./FormSocialProfileQuestionSettings.vue?vue&type=script&lang=js"
export * from "./FormSocialProfileQuestionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports